import { createSvgIcon } from '@mui/material';

export const PlusSvgIcon =
    createSvgIcon(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke='currentColor'>
          <path d="M6 12H18M12 6V18"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>,
        'Plus'
    )